module.exports = __webpack_public_path__ + "img/cydcf1.c3aa2a2d.png";